import React from 'react'
import { Box } from '@mui/material'
import Image from 'next/image'
import BrandLogo from '../../../brandLogo'
import ClearTripLogo from '@/src/assets/png/ClearTripLogo.png'

interface HeaderLogoProps {
    variant: 'flyin' | 'cleartrip' | 'mobile'
    locale: string
    onClick?: () => void
    domainCountry?: string
}

const HeaderLogo: React.FC<HeaderLogoProps> = ({ variant, locale, onClick, domainCountry }) => {
    const handleClick = onClick || (() => {
        if (variant === 'cleartrip') {
            window.location.href = '/'
        } else {
            window.location.href = `/${locale}`
        }
    })

    // For mobile variant, determine logo based on domainCountry if provided
    const shouldShowCleartripLogo = variant === 'cleartrip' || (variant === 'mobile' && domainCountry && domainCountry !== 'FEG' && domainCountry !== 'FSA' && domainCountry !== 'FAE')

    if (shouldShowCleartripLogo) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    height: variant === 'mobile' ? 26 : 32
                }}
                onClick={handleClick}
            >
                <Image
                    src={ClearTripLogo}
                    alt="Cleartrip"
                    height={variant === 'mobile' ? 26 : 32}
                    width={100}
                    style={{ objectFit: 'contain' }}
                    priority
                />
            </Box>
        )
    }

    return (
        <Box
            sx={{
                height: variant === 'mobile' ? 26 : { xs: 22, sm: 26 },
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer'
            }}
            onClick={handleClick}
        >
            <BrandLogo />
        </Box>
    )
}

export { HeaderLogo }
export type { HeaderLogoProps }
